import dropRight from './dropRight.js';

export default function initial(a) {
  return dropRight(1, a);
}